
let YourDetails = Backbone.Model.extend(
    {
        defaults:
            {
                firstName: null,
                lastName: null,
                email: null,
                agreeTcs: null
            },

        initialize: function () {
            restoreValueFromCookie(this, 'firstName', 'YourDetails');
            restoreValueFromCookie(this, 'lastName', 'YourDetails');
            restoreValueFromCookie(this, 'email', 'YourDetails');
            restoreValueFromCookie(this, 'agreeTcs', 'YourDetails');
            this.set('agreeTcs', this.get('agreeTcs') === "true");
        },

        updateTo: function (firstName, lastName, email, agree) {
            this.set('firstName', firstName);
            this.set('lastName', lastName);
            this.set('email', email);
            this.set('agreeTcs', agree);

            storeValueInCookie(this, 'firstName', 'YourDetails');
            storeValueInCookie(this, 'lastName', 'YourDetails');
            storeValueInCookie(this, 'email', 'YourDetails');
            storeValueInCookie(this, 'agreeTcs', 'YourDetails');
        },

        isComplete: function () {
            return fieldIsNotEmpty(this.get('firstName')) &&
                fieldIsNotEmpty(this.get('lastName')) &&
                fieldIsEmail(this.get('email')) &&
                this.get('agreeTcs') !== null &&
                this.get('agreeTcs') === true;
        },

        getFirstName: function () {
            return this.get('firstName');
        },

        getLastName: function () {
            return this.get('lastName');
        },

        getEmail: function () {
            return this.get('email');
        },

        hasAgreedTCs: function () {
            return this.get('agreeTcs') != null && this.get('agreeTcs');
        }

    }
);
